angular.module('unica_approvation_list.approvation_list_services')

.factory('ApprovationListEditService', function ($http, getBaseApiURL) {

	var approvationListEditService = {};

	approvationListEditService.update = function ( approvationListData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/update/' + approvationListData.id,
			data: approvationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});
	};

	approvationListEditService.resetStatus = function ( approvationListId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/reset-status/' + approvationListId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});

	};

	approvationListEditService.sendAll = function ( invitationListId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/send-all/' + invitationListId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_lists;
			}

		});
	};

	approvationListEditService.send = function ( approvationListId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/send/' + approvationListId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});
	};

	approvationListEditService.updateStatus = function ( id, status ) {
		console.log('approvationListEditService.updateStatus');
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/set-status/' + id,
			data: {
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});
	};

	return approvationListEditService;
});